export enum EPartType {
  GENERIC_PART = 'generic_part',
  GENERIC = 'generic',
  PART = 'part',
  SINGLE = 'single',
  SUPPLY = 'supply',
}
